export var E_SHORTCUT_DATE_TYPE;
(function (E_SHORTCUT_DATE_TYPE) {
    E_SHORTCUT_DATE_TYPE[E_SHORTCUT_DATE_TYPE["LAST_HOUR"] = 0] = "LAST_HOUR";
    E_SHORTCUT_DATE_TYPE[E_SHORTCUT_DATE_TYPE["TODAY"] = 1] = "TODAY";
    E_SHORTCUT_DATE_TYPE[E_SHORTCUT_DATE_TYPE["LAST_24_HOURS"] = 2] = "LAST_24_HOURS";
    E_SHORTCUT_DATE_TYPE[E_SHORTCUT_DATE_TYPE["YESTERDAY"] = 3] = "YESTERDAY";
    E_SHORTCUT_DATE_TYPE[E_SHORTCUT_DATE_TYPE["THIS_WEEK"] = 4] = "THIS_WEEK";
    E_SHORTCUT_DATE_TYPE[E_SHORTCUT_DATE_TYPE["THIS_MONTH"] = 5] = "THIS_MONTH";
})(E_SHORTCUT_DATE_TYPE || (E_SHORTCUT_DATE_TYPE = {}));
export var SHORTCUT_DATES = [
    { type: E_SHORTCUT_DATE_TYPE.LAST_HOUR, labelKey: 'last1h', startDate: 'now-1h', endDate: 'now' },
    { type: E_SHORTCUT_DATE_TYPE.TODAY, labelKey: 'today', startDate: 'now/d', endDate: 'now/d' },
    {
        type: E_SHORTCUT_DATE_TYPE.LAST_24_HOURS,
        labelKey: 'last24h',
        startDate: 'now-1d',
        endDate: 'now',
    },
    { type: E_SHORTCUT_DATE_TYPE.YESTERDAY, labelKey: 'yesterday', startDate: 'now-1d/d', endDate: 'now-1d/d' },
    {
        type: E_SHORTCUT_DATE_TYPE.THIS_WEEK,
        labelKey: 'thisWeek',
        startDate: 'now/w',
        endDate: 'now/w',
    },
    { type: E_SHORTCUT_DATE_TYPE.THIS_MONTH, labelKey: 'thisMonth', startDate: 'now/M', endDate: 'now/M' },
];
export var E_DATE_TAB;
(function (E_DATE_TAB) {
    E_DATE_TAB[E_DATE_TAB["SUGGESTION"] = 0] = "SUGGESTION";
    E_DATE_TAB[E_DATE_TAB["CUSTOM"] = 1] = "CUSTOM";
    E_DATE_TAB[E_DATE_TAB["FROM"] = 2] = "FROM";
})(E_DATE_TAB || (E_DATE_TAB = {}));
export var DATE_TABS = [
    { labelKey: 'suggestion', type: E_DATE_TAB.SUGGESTION },
    { labelKey: 'from', type: E_DATE_TAB.FROM },
    { labelKey: 'custom', type: E_DATE_TAB.CUSTOM },
];
// Default labels displayed when the i18n dictionary does not provide the matching key
export var DEFAULT_OVERVIEW_FROM_LABEL = 'du';
export var DEFAULT_OVERVIEW_TO_LABEL = 'au';
export var DEFAULT_TIME_LABEL = 'à :';
export var IDENTIFIER_DATETIME_INPUT = 'datetime-input';
export var IDENTIFIER_DATETIME_INPUT_VALUE = 'datetime-input-value';
export var IDENTIFIER_DATETIME_INPUT_SHORTCUT_OPTIONS = 'datetime-input-shortcut-options';
export var IDENTIFIER_DATETIME_INPUT_SHORTCUT_OPTION_ITEM = 'datetime-input-shortcut-option-item';
export var IDENTIFIER_DATETIME_INPUT_CALENDAR = 'datetime-input-calendar';
export var IDENTIFIER_DATETIME_INPUT_CALENDAR_DAY_ITEM = 'datetime-input-calendar-day-item';
export var IDENTIFIER_DATETIME_INPUT_CALENDAR_TIME = 'datetime-input-calendar-time';
export var IDENTIFIER_DATETIME_TABS = 'datetime-input-tabs';
